<a class="nav-link" mat-ripple [routerLink]="[item.url]" routerLinkActive="active" [matTooltip]="item.title" matTooltipPosition="after">
    <mat-icon class="nav-link-icon" *ngIf="item.icon">{{item.icon}}</mat-icon>
    <!-- <span class="nav-link-title">{{item.title}}</span>
    <span class="nav-link-badge" *ngIf="item.badge" [ngStyle]="{'background-color': item.badge.bg,'color': item.badge.fg}">{{item.badge.title}}</span> -->
</a>


// WEBPACK FOOTER //
// ./src/app/core/components/navigation/vertical/nav-item/nav-vertical-item.component.html